<template>
    <div class="page-block | u-margin-bottom-narrow">
        <div class="page-block__item-wrapper" v-if="user">
            <h2 class="page-block__title | u-font-weight-normal">{{ trans('profile.user.title') }}</h2>
            <div class="page-block__item">
                <div class="page-block__item-content">
                    <div class="layout">
                        <div class="layout__item u-1/4-desk">
                            <span class="page-block__item-content-title"> {{ trans('profile.email') }} </span>
                        </div>
                        <!--
                     -->
                        <div class="layout__item u-3/4-desk">{{ user.email }}</div>
                    </div>
                    <div class="layout">
                        <div class="layout__item u-1/4-desk">
                            <span class="page-block__item-content-title"> {{ trans('profile.first_name') }} </span>
                        </div>
                        <!--
                     -->
                        <div class="layout__item u-3/4-desk">{{ user.first_name }}</div>
                    </div>
                    <div class="layout">
                        <div class="layout__item u-1/4-desk">
                            <span class="page-block__item-content-title"> {{ trans('profile.last_name') }} </span>
                        </div>
                        <!--
                     -->
                        <div class="layout__item u-3/4-desk">{{ user.last_name }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters({
            user: 'user/user'
        })
    }
};
</script>
